import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ref, get } from "firebase/database";
import { database } from "../firebaseConfig";
import MiniAppRenderer from "./MiniAppRenderer";
import { sanitizeDesign } from "./miniAppDesign";
import "./MiniApp.css";

const GONE = "Diese Anwendung ist nicht mehr verfügbar.";

/**
 * Public page of a per-contact Mini-App: /miniapp/{publicId}, without any
 * BonusClub branding. Specs are written only by the server after validation;
 * the database rules stop serving an app once its `expiresAt` has passed and
 * the daily retention job deletes it.
 */
const MiniAppPublic = () => {
  const { publicId } = useParams();
  const [state, setState] = useState({ loading: true, spec: null, error: "" });

  useEffect(() => {
    let alive = true;
    if (!publicId || !/^[A-Za-z0-9_-]{10,64}$/.test(publicId)) {
      setState({ loading: false, spec: null, error: "Dieser Link ist ungültig." });
      return undefined;
    }
    get(ref(database, `/publicMiniApps/${publicId}`))
      .then((snap) => {
        if (!alive) return;
        const app = snap.exists() ? snap.val() : null;
        const spec = app && app.expiresAt > Date.now() ? app.spec : null;
        setState({ loading: false, spec, error: spec ? "" : GONE });
      })
      .catch((err) => {
        if (!alive) return;
        const denied = /permission/i.test(String(err?.code || err?.message || ""));
        setState({ loading: false, spec: null, error: denied ? GONE : "Die Anwendung konnte nicht geladen werden." });
      });
    return () => {
      alive = false;
    };
  }, [publicId]);

  const title = state.spec?.title || "Mini-App";
  const theme = sanitizeDesign(state.spec?.design).theme;

  return (
    <div className={`ma-page ma-page--${theme}`}>
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="referrer" content="no-referrer" />
        <link rel="icon" href="data:," />
      </Helmet>
      {state.loading ? (
        <div className="ma-state">Lädt…</div>
      ) : state.error ? (
        <div className="ma-state">{state.error}</div>
      ) : (
        <MiniAppRenderer spec={state.spec} />
      )}
    </div>
  );
};

export default MiniAppPublic;
